import { schema } from 'normalizr';

const machine = new schema.Entity('machines', {}, { idAttribute: 'id' });
const machinesSchema = [machine];

export default machinesSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/machinesSchema.js